"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _antd = require("antd");

var _EventDetails = _interopRequireDefault(require("./EventDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventPopover = function EventPopover(_ref) {
  var event = _ref.event,
      children = _ref.children,
      view = _ref.view;
  return /*#__PURE__*/_react.default.createElement(_antd.Popover, {
    overlayClassName: "event-popover",
    content: /*#__PURE__*/_react.default.createElement(_EventDetails.default, event),
    trigger: ['click'],
    placement: view === 'day' ? 'bottom' : 'right'
  }, children);
};

EventPopover.propTypes = {
  event: _propTypes.default.shape({
    color: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    startDate: _propTypes.default.string,
    endDate: _propTypes.default.string,
    currentDay: _propTypes.default.instanceOf(Date).isRequired
  }).isRequired,
  view: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  onChange: _propTypes.default.func.isRequired
};
var _default = EventPopover;
exports.default = _default;